<template>
  <vx-tooltip position="bottom"
              :title="isOnline ? 'Operators are online' : 'Operators are offline'"
              :text="TOOLTIP_TEXT"
              ref="tooltip"
              @mouseenter.native="isHovered = true"
              @mouseleave.native="isHovered = false"
  >
    <base-switch ref="operatorStatusSwitch"
                 :variant="isOnline ? 'operator-toggle-on' : 'operator-toggle-off'"
                 v-model="isOnlineValue"
                 :disabled="isLoading"
                 :key="refreshToggleKey"
    >
      <template #default>
        <div class="h-6 w-6 flex items-center">
          <operator-online-icon v-if="isOnline"/>
          <operator-offline-icon v-else/>
        </div>
      </template>
      <template #checked>
        <operator-offline-icon class="h-6 w-6"
                               :class="{ 'text-focus-error': isHovered }"
        />
      </template>
      <template #unchecked>
        <operator-online-icon class="h-6 w-6"
                              :class="{ 'text-success': isHovered }"
        />
      </template>
    </base-switch>
  </vx-tooltip>
</template>

<script>
import OperatorOnlineIcon from '@/assets/images/icons/OperatorOnlineIcon'
import OperatorOfflineIcon from '@/assets/images/icons/OperatorOfflineIcon'
import botService from '@/services/amio/bot.service'
import toaster from '@/utils/toaster'
import botModule from '@/store/modules/bot.module'

const TOOLTIP_TEXT = `<div class="text-center w-full">
        Virtual assistant can respond differently based on whether the operators are online or offline.
        It has no effect unless you use a condition case called "Operator Status".
      </div>`

export default {
  name: 'OperatorStatusSwitch',

  components: {
    OperatorOnlineIcon,
    OperatorOfflineIcon
  },

  props: {
    botId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isOnline: false,
      isLoading: false,
      refreshToggleKey: 0,
      isHovered: false,
      TOOLTIP_TEXT
    }
  },

  watch: {
    bot: {
      immediate: true,
      deep: true,
      handler() {
        this.setOperatorStatus()
      }
    }
  },

  computed: {
    bot: botModule.getBot,
    botList: botModule.getBotList,

    isOnlineValue: {
      get() {
        return this.isOnline
      },
      set(isOnline) {
        this.toggleOperatorStatus(isOnline)
      }
    }
  },

  methods: {
    setOperatorStatus() {
      this.isLoading = true
      const { is_operator_available } = this.bot
      this.isOnline = is_operator_available
      this.isLoading = false
      this.resetToggle()
    },

    async toggleOperatorStatus(isOnline) {
      this.isLoading = true
      try {
        const updatedBot = await botService.update(this.botId, {
          is_operator_available: isOnline
        })

        botModule.setBot(updatedBot)
        const updatedBotList = this.botList.map(bot => bot.id === updatedBot.id ? updatedBot : bot)
        botModule.setBotList(updatedBotList)
        this.$refs.tooltip.mouseenterx()
        this.isOnline = isOnline
      } catch (err) {
        toaster.error(err)
      } finally {
        this.isLoading = false
      }
    },

    resetToggle() {
      this.refreshToggleKey = Math.random()
    }
  }
}
</script>
